

const containerA = ['100%'];
const containerB = ['50%', '50%'];
const containerC = ['25%', '25%', '25%', '25%'];
const containerD = ['25%', '75%'];
const containerE= ['75%', '25%'];
const containerF = ['33.3%', '33.3%', '33.3%'];
const containerG = ['33.5%', '66.5%'];
const containerH = ['66.5%', '33.5%'];
const containerJ = ['25%', '50%', '25%'];

export const containers = [
    { id: 'A', type: containerA },
    { id: 'B', type: containerB },
    { id: 'C', type: containerC },
    { id: 'D', type: containerD },
    { id: 'E', type: containerE },
    { id: 'F', type: containerF },
    { id: 'G', type: containerG },
    { id: 'H', type: containerH },
    { id: 'J', type: containerJ },

]